export var NotificationObjectType;
(function (NotificationObjectType) {
    NotificationObjectType["grant"] = "grant";
    NotificationObjectType["industry"] = "industry";
    NotificationObjectType["tag"] = "tag";
})(NotificationObjectType || (NotificationObjectType = {}));
export var NotificationFrequency;
(function (NotificationFrequency) {
    NotificationFrequency["instant"] = "instant";
    NotificationFrequency["daily"] = "daily";
    NotificationFrequency["weekly"] = "weekly";
})(NotificationFrequency || (NotificationFrequency = {}));
export const grantNotificationFieldsArray = [
    'grant_title_en',
    'grant_title_fr',
    'grant_display_title_en',
    'grant_display_title_fr',
    'grant_description_short_en',
    'grant_description_short_fr',
    'grant_description_long_en',
    'grant_description_long_fr',
    'grant_financing_type',
    'grant_providers',
    'funding_max_amount',
    'funding_min_amount',
    'total_funding_available',
    'needed_investment',
    'applicants_min_revenue_past_year',
    'applicants_max_revenue_past_year',
    'applicants_min_count_employee',
    'applicants_max_count_employee',
    'city',
    'region',
    'province',
    'country',
    'service',
    'audience',
    'eligibility_criteria_short_en',
    'eligibility_criteria_short_fr',
    'eligibility_criteria_en',
    'eligibility_criteria_fr',
    'eligible_expenses_en',
    'eligible_expenses_fr',
    'who_can_apply_en',
    'who_can_apply_fr',
    'who_cannot_apply_en',
    'who_cannot_apply_fr',
    'project_activity_en',
    'project_activity_fr',
    'zone_en',
    'zone_fr',
    'selection_criteria_en',
    'selection_criteria_fr',
    'steps_how_to_apply_en',
    'steps_how_to_apply_fr',
    'funding_terms_and_conditions_en',
    'funding_terms_and_conditions_fr',
    'grant_timeline',
    'quebec_administrative_region',
    'quebec_mrc',
    'financing_type',
    'providers',
    'industry_sectors',
    'industry_subsectors',
    'Tags',
    'size',
];
export const grantNotificationFieldsSet = new Set(grantNotificationFieldsArray);
